import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';

@Component({
  selector: 'app-link-share',
  templateUrl: './link-share.component.html',
  styleUrls: ['./link-share.component.css'],
  exportAs: 'LinkShareModal'
})
export class LinkShareComponent implements OnInit {
  shareUrl:string='';
  shareTitle:string=null;
  shareDescription:string=null;
  shareImage:string=null;
  twShare:string='';
  twUrl:string='';
  shareType: any;
  @ViewChild('LinkShareModal') public LinkShareModal: ModalDirective;
  constructor(@Inject(DOCUMENT) private document: Document,
  private mixpanelEventLoggingService: MixpanelEventLoggingService
) { }

  ngOnInit() {
  }

  logMixpanel(title: string, via: string) {
    if (this.shareType === "research") {
      this.shareType = "research_document";
    }
    this.mixpanelEventLoggingService.dispatchEvent("share", {
      "Item Type": this.shareType ? this.shareType : '' ,
      "Item Name": title ? title : '',
      "Share Via": via ? via : ''
    });
  }

  showModal(type:string,data,id:string = ''){
    this.shareType = type;
    if(type==='research'|| data.researchId)
    {
      if(id)
        this.shareUrl = `${environment.SOCIAL_SHARE_URL}?id=${id}&type=research_document`;
      else
      {
        if(data.postType === 'research_document' || data.itemType === 'research_document') {
          this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.postId}` ;
        } else if (data.researchId) {
          this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.researchId}` ;
        } else {
          this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.id}` ;
        }
      }
      if(data.research){
        this.shareTitle = `Ecosystm - ${data.research.title}`;
        this.shareDescription = 'Hi, I found this research content on the Ecosystm platform. I thought it may be of interest to you.';
        this.twShare = `${data.research.title}`;
        this.twUrl = this.shareUrl
      }
      else{
        this.shareTitle=`Ecosystm - ${data.title}`;
        this.shareDescription='Hi, I found this research content on the Ecosystm platform. I thought it may be of interest to you.';
        this.twShare = `${data.title}`;
        this.twUrl = this.shareUrl;
      }

    }
    else if(type=='report'){
      if(data.postType === 'report' || data.itemType === 'report') {
        this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.postId}` ;
      } else {
        this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.id}` ;
      }
      this.shareTitle= `Ecosystm - ${data.title}`;
      this.shareDescription='Hi, I found this content on the Ecosystm platform. I thought it may be of interest to you.';
      this.twShare = `${data.title}`;
      this.twUrl = this.shareUrl;
    } // added package subscription
    else if(type=='package_subscription'){
      if(data.postType === 'package_subscription' || data.itemType === 'package_subscription') {
        this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.postId}` ;
      } else {
        this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.id}` ;
      }
      this.shareTitle= `Ecosystm - ${data.packageName}`;
      this.shareDescription='Hi, I found this content on the Ecosystm platform. I thought it may be of interest to you.';
      this.twShare = `${data.packageName}`;
      this.twUrl = this.shareUrl; 
    }
    else if(type == 'analyst'){
      this.shareTitle= `Ecosystm - ${data.title}`;
      this.shareDescription='Hi, I found this content on the Ecosystm platform. I thought it may be of interest to you.';
      this.shareUrl = `${document.location.origin}/#/link?type=${type}&id=${data.postId}` ;
      this.twShare = `${data.title}`;
      this.twUrl = this.shareUrl;
    }
    else {
      this.shareUrl = `${document.location.origin}/#/link?type=${type}` ;
      this.twShare = `${data.title}`;
      this.twUrl = this.shareUrl;
    };
    this.LinkShareModal.show();
  }
  hideModal(){
    this.LinkShareModal.hide()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/link-share/link-share.component.ts